import type { SituacaoDoExtrato } from "@bookdental/schemas";

export const COR_DA_SITUACAO_DO_EXTRATO: Record<SituacaoDoExtrato, string> = {
  QUITADO: "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400",
  PARCIAL: "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-400",
  EM_ABERTO: "bg-zinc-100 text-zinc-600 dark:bg-muted dark:text-muted-foreground",
  VENCIDO: "bg-red-50 text-red-700 dark:bg-red-500/10 dark:text-red-400",
  CREDITO: "bg-brand-50 text-brand-700 dark:bg-primary/10 dark:text-primary",
  PERDIDO: "bg-zinc-100 text-red-700 dark:bg-muted dark:text-red-400",
  CANCELADO: "bg-zinc-100 text-zinc-400 line-through dark:bg-muted dark:text-muted-foreground",
};

export const mesDoExtrato = (rotulo: string) => `${rotulo.slice(5, 7)}/${rotulo.slice(0, 4)}`;
export const dataCurta = (d: string) => `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}`;

const diaMes = (d: Date | string) => new Date(d).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", timeZone: "America/Sao_Paulo" });

/** "Enviado 28/10 · visto 29/10", "Enviado 28/10" ou "Não enviado". */
export function envioDoExtrato(e: { enviadoEm: Date | string | null; visualizadoEm: Date | string | null }) {
  if (!e.enviadoEm) return e.visualizadoEm ? `Visto ${diaMes(e.visualizadoEm)}` : "Não enviado";
  return `Enviado ${diaMes(e.enviadoEm)}${e.visualizadoEm ? ` · visto ${diaMes(e.visualizadoEm)}` : ""}`;
}
